import { getShowIncludedSeatsDisplay, getShowPricePerMonthPerSeat } from 'pricing-pages-lib/utils/merchCardUtils';
import { createSelectorFromUtil } from 'pricing-pages-lib/utils/selectorUtils';
import { transformState } from './SelectorUtils';
export const showPricePerMonthPerSeatSelector = createSelectorFromUtil(getShowPricePerMonthPerSeat, transformState);
export const showIncludedSeatsDisplaySelector = createSelectorFromUtil(getShowIncludedSeatsDisplay, transformState);